export const environment = {
      // baseURL: 'https://localhost:7187/api/',  
      baseURL: 'https://api.successinstitute1.com/api/',
      // imageURL: 'https://localhost:7187', 
      imageURL: 'https://api.successinstitute1.com',
      websiteURL: 'https://successinstitute1.com',
      production: true
};
